export default ({ name, type = '', value, placeholder, errors = [], onChange = {}, readonly = false, select = false, fill = false, onSelect = ()=> console.log('Selected') }) => {
    return (
        <div className="input-outer">
            <label for={name}>{ placeholder }</label>

            <textarea id={name} readOnly={readonly} type={type} className={errors.length > 0 ? "input-outer__error" : ""} placeholder={placeholder} name={name} value={value || ''} onChange={onChange}/>

            { errors.length > 0 && <div className="input-outer__errors">{ errors.map(err => <p>{ err }</p>) }</div> }

        </div>
    )
}
